<template>
  <div class="py-3" style="background-color: white">
    <div class="d-flex justify-content-between align-items-center pb-3 px-5" style="border-bottom:#D6D5D5 solid 1px">
      <p class="mb-0" style="font-size:16px;font-weight:500">Quản lý tác vụ</p>
      <div class="d-flex align-items-center gap-2">
        <button type="button" class="btn btn-primary mr-2" :disabled="loadingExport" @click="openExportModal">
          <i class="fa fa-upload mr-1"></i> Export
        </button>
        <button type="button" class="btn btn-info mr-2" :disabled="loadingExport" @click="openImportModal">
          <i class="el-icon-upload mr-1"></i> Import
        </button>
        <button type="button" class="btn btn-success" @click="openCreate">
          <i class="fa fa-plus mr-1"></i> Thêm mới
        </button>
      </div>
    </div>

    <div class="px-5">
      <div class="grid-filter">
        <div>
          <p>Mã tác vụ</p>
          <el-input
            v-model="filters.code"
            placeholder="Nhập mã tác vụ"
            clearable
            class="w-100"
            size="medium"
            @input="getList(true)"
          >
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>

        <div>
          <p>Tác vụ</p>
          <el-select
            v-model="filters.taskType"
            placeholder="Chọn loại tác vụ"
            clearable
            style="width:100%"
            size="medium"
            @change="getList(true)"
          >
            <el-option v-for="t in taskTypes" :key="t.id" :label="t.name" :value="t.id" />
          </el-select>
        </div>

        <div v-if="filters.taskType === 4">
          <p>Phân loại</p>
          <el-select
            v-model="filters.tutorType"
            placeholder="Chọn loại"
            clearable
            style="width:100%"
            size="medium"
            multiple
            @change="getList(true)"
          >
            <el-option v-for="s in subtypes" :key="s.id" :label="s.label" :value="s.id" />
          </el-select>
        </div>

        <div>
          <p>Đối tượng xử lý</p>
          <el-input
            v-model="filters.target"
            placeholder="Tên, điện thoại"
            clearable
            class="w-100"
            size="medium"
            @input="getList(true)"
          />
        </div>

        <div>
          <p>Trạng thái</p>
          <el-select
            v-model="filters.status"
            placeholder="Chọn trạng thái"
            clearable
            style="width:100%"
            size="medium"
            @change="getList(true)"
          >
            <el-option v-for="s in statusOptions" :key="s.value" :label="s.label" :value="s.value" />
          </el-select>
        </div>

        <div>
          <p>Thời gian làm</p>
          <el-date-picker
            v-model="filters.startRange"
            type="daterange"
            range-separator="đến"
            start-placeholder="Từ ngày"
            end-placeholder="Đến ngày"
            align="right"
            unlink-panels
            clearable
            class="w-100"
            size="medium"
            @change="getList(true)"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
          />
        </div>

        <div>
          <p>Thời gian tạo</p>
          <el-date-picker
            v-model="filters.createRange"
            type="daterange"
            range-separator="đến"
            start-placeholder="Từ ngày"
            end-placeholder="Đến ngày"
            align="right"
            unlink-panels
            clearable
            class="w-100"
            size="medium"
            @change="getList(true)"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
          />
        </div>

        <div>
          <p>Người phụ trách</p>
          <el-select
            v-model="filters.assignee"
            placeholder="Chọn người phụ trách"
            clearable
            filterable
            size="medium"
            class="w-100"
            @change="getList(true)"
          >
            <el-option
              v-for="u in allTutor"
              :key="u.id"
              :label="`${u.user_name} - ${u.user_phone || ''}`"
              :value="u.id"
            />
          </el-select>
        </div>

        <div>
          <p>Đánh giá sao</p>
          <el-select
            v-model="filters.starRate"
            size="medium"
            placeholder="Chọn đánh giá sao"
            class="w-100"
            multiple
            clearable
            @change="getList(true)"
          >
            <el-option v-for="item in starList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </div>
      </div>

      <el-table :data="rows" border size="small" style="width:100%" height="550" lazy v-loading="loading">
        <el-table-column label="Mã tác vụ" prop="code" min-width="100" />
        <el-table-column label="Tác vụ" min-width="120">
          <template slot-scope="scope">
            <span :class="getClassType(scope.row.type)" style="padding: 4px 8px; border-radius: 4px; white-space: nowrap">
              {{ scope.row.taskTypeName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Phân loại" prop="categoryName" min-width="140">
          <template slot-scope="scope">
            <span style="word-break: break-word">
              {{ scope.row.categoryName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Đối tượng xử lý" prop="target" min-width="120">
          <template slot-scope="scope">
            <div class="d-flex align-items-center">
              <span style="word-break: keep-all">{{ scope?.row?.target ?? '' }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Trạng thái" prop="status" min-width="150">
          <template slot-scope="scope">
            <p v-if="scope.row.taskTypeName === 'Tác vụ khác'">-</p>
            <span v-else :class="getClassStatus(scope.row.status)" style="padding: 4px 8px; border-radius: 4px; white-space: nowrap">
              {{ statusLabel(scope.row.status) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Đánh giá sao" prop="rating" min-width="100" />
        <el-table-column label="Thời gian làm" prop="workTime" min-width="180" />
        <el-table-column label="Người phụ trách" prop="assigneeName" min-width="150" />
        <el-table-column label="Thời gian tạo" prop="createdAt" min-width="120" />
        <el-table-column label="Hành động" min-width="110">
          <template slot-scope="scope">
            <RouterLink
              v-if="scope.row.taskTypeName === 'Gia sư'"
              class="btn btn-xs btn-icon mr-2 btn-outline-info"
              title="Xem chi tiết"
              :to="{ name: 'tutor-detail-task', params: { id: scope.row.code } }"
            >
              <i class="far fa-eye"></i>
            </RouterLink>
            <button
              v-if="scope.row.status === 3 && scope.row.taskTypeName === 'Gia sư'"
              @click="actionMarkHomework(scope.row)"
              class="btn btn-xs btn-icon mr-2 btn-outline-success"
              title="Chấm BTVN"
            >
              <i class="el-icon-edit"></i>
            </button>
            <button
              v-if="!isMockSupplementTask(scope.row) && (scope.row.taskTypeName === 'Tác vụ khác' || (scope.row.taskTypeName === 'Gia sư' && +scope.row.status === 0))"
              class="btn btn-xs btn-icon mr-2 btn-outline-info"
              title="Sửa"
              @click="editTask(scope.row)"
            >
              <i class="fas fa-pen-nib"></i>
            </button>
            <a
              v-if="!isMockSupplementTask(scope.row) && (scope.row.taskTypeName === 'Tác vụ khác' || (scope.row.taskTypeName === 'Gia sư' && +scope.row.status === 0))"
              title="Xóa"
              href="javascript:"
              class="btn btn-xs btn-icon btn-outline-danger"
              @click="deleteTask(scope.row)"
            >
              <i class="fas fa-trash"></i>
            </a>
          </template>
        </el-table-column>
      </el-table>

      <div class="edu-paginate mx-auto text-center d-flex justify-content-between mt-4">
        <div class="spacer"></div>
        <paginate
          v-model="page"
          :page-count="lastPage"
          :page-range="3"
          :margin-pages="1"
          :click-handler="clickPage"
          :prev-text="'Trước'"
          :next-text="'Sau'"
          :container-class="'pagination b-pagination'"
          :page-link-class="'page-link'"
          :next-link-class="'next-link-item'"
          :prev-link-class="'prev-link-item'"
          :prev-class="'page-link'"
          :next-class="'page-link'"
          :page-class="'page-item'"
        />
        <div class="right-div">Tổng số bản ghi: <span style="color:#0066FF">{{ total }}</span></div>
      </div>
    </div>

    <AddTaskManagementIndex @loadList="getList(false)" />
    <EditOtherTask :task="selectedTask" @loadList="getList(false)" />
    <EditTutorTask :task="selectedTask" @loadList="getList(false)" />
    <TutorTaskImportModal />

    <el-dialog title="Xóa tác vụ" :visible.sync="deleteOtherTaskVisible" width="30%">
      <p>Bạn chắc chắn muốn hủy tác vụ này?</p>
      <div class="d-flex justify-content-end gap-3">
        <button type="button" class="btn btn-secondary" @click="deleteOtherTaskVisible = false">Hủy bỏ</button>
        <button type="button" class="btn btn-info" @click="deleteOtherTask()">Xác nhận</button>
      </div>
    </el-dialog>

    <el-dialog
      title="Hủy ca học"
      :visible.sync="deleteTutorTaskVisible"
      width="30%"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <ValidationObserver v-slot="{ handleSubmit }" v-if="deleteTutorTaskVisible">
        <form class="form" autocomplete="off" @submit.prevent="handleSubmit(deleteTutorTask)">
          <p>Vui lòng nhập lý do hủy ca</p>
          <ValidationProvider name="Lý do hủy" rules="required" v-slot="{ errors }">
            <el-input v-model="cancellationReason" type="textarea" :rows="4" placeholder="Vui lòng nhập"></el-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>

          <div class="d-flex justify-content-end gap-3">
            <button type="button" class="btn btn-secondary" @click="cancelDeleteTutor()">Hủy bỏ</button>
            <button type="button" class="btn btn-info" @click="handleSubmit(deleteTutorTask)">Xác nhận</button>
          </div>
        </form>
      </ValidationObserver>
    </el-dialog>

    <el-dialog
      :visible.sync="exportModalVisible"
      :width="exportDataType === 'student' ? '650px' : '461px'"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      custom-class="export-data-dialog"
    >
      <div
        v-loading="loadingExport"
        class="export-data-modal"
        element-loading-text="Đang chuẩn bị file export..."
      >
        <p class="export-data-modal__title">Vui lòng chọn dữ liệu để tải xuống</p>
        <div class="export-data-modal__divider"></div>

        <el-radio-group v-model="exportDataType" class="export-data-modal__options" @change="onExportTypeChange">
          <el-radio label="tutor">Dữ liệu ca gia sư</el-radio>
          <el-radio label="student">Dữ liệu học viên</el-radio>
        </el-radio-group>

        <div v-if="exportDataType === 'student'" class="export-data-modal__filters">
          <div class="export-data-modal__field">
            <label>Trạng thái</label>
            <el-select v-model="exportStudentFilters.registrationStatus" placeholder="Chọn trạng thái" clearable class="w-100">
              <el-option label="Đã đăng ký" :value="1" />
              <el-option label="Chưa đăng ký" :value="2" />
            </el-select>
          </div>
          <div class="export-data-modal__field">
            <label>Phân loại gia sư</label>
            <el-select v-model="exportStudentFilters.tutorSubtype" placeholder="Chọn phân loại gia sư" class="w-100">
              <el-option label="Gia sư bổ trợ" :value="8" />
            </el-select>
          </div>
          <div class="export-data-modal__field">
            <label>Cơ sở</label>
            <el-select v-model="exportStudentFilters.branchId" placeholder="Chọn cơ sở" clearable filterable :loading="loadingExportBranches" class="w-100">
              <el-option v-for="branch in exportBranches" :key="branch.id" :label="branch.name" :value="branch.id" />
            </el-select>
          </div>
          <div class="export-data-modal__field">
            <label>Thời gian giáo viên nhận xét</label>
            <el-date-picker
              v-model="exportStudentFilters.teacherReviewDateRange"
              type="daterange"
              range-separator="-"
              start-placeholder="Từ ngày"
              end-placeholder="Đến ngày"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              unlink-panels
              clearable
              class="w-100"
            />
          </div>
        </div>

        <div class="export-data-modal__actions">
          <button type="button" class="export-data-modal__close" :disabled="loadingExport" @click="closeExportModal">Đóng</button>
          <button type="button" class="export-data-modal__submit" :disabled="loadingExport" @click="handleExportData">
            {{ loadingExport ? 'Đang export...' : 'Export' }}
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddTaskManagementIndex from "@/view/pages/tutor/task-management/add-task-management/AddTaskManagementIndex.vue";
import {
  CANCEL_TUTOR_TASK,
  DELETE_OTHER_TASK,
  EXPORT_SUPPLEMENTARY_TUTOR_STUDENTS,
  EXPORT_TUTOR_TASK_MANAGEMENT,
  GET_ALL_TUTOR,
  GET_LIST_TASK
} from "@/core/services/store/tutor/tutor.module";
import EditOtherTask from "@/view/pages/tutor/task-management/edit-task/EditOtherTask.vue";
import { nextTick } from "vue";
import EditTutorTask from "@/view/pages/tutor/task-management/edit-task/EditTutorTask.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { exportExcel } from "@/core/filters";
import { toArray, toNumber, toNumberArray } from "../../../../core/filters";
import TutorTaskImportModal from "./import-task/TutorTaskImportModal.vue";
import { getSupplementTutorMockTasks } from "@/core/mock/tutorSupplement.mock";
import { GET_ALL_BRANCHES } from "@/core/services/store/center/branch.module";
import ApiService from '@/core/services/api.service';

export default {
  name: 'TaskManagementIndex',
  components: { EditTutorTask, EditOtherTask, AddTaskManagementIndex, TutorTaskImportModal },
  data() {
    return {
      filters: {
        code: '',
        taskType: '',
        target: '',
        status: null,
        startRange: [],
        assignee: '',
        createRange: [],
        starRate: null,
        tutorType: []
      },
      statusOptions: [
        { label: 'Cần làm', value: 0 },
        { label: 'Hoàn thành', value: 1 },
        { label: 'Hủy', value: 2 },
        { label: 'Cần chấm BTVN', value: 3 },
        { label: 'Hoàn thành buổi học', value: 4 },
        { label: 'Cần đánh giá', value: 6 }
      ],
      subtypes: [
        { id: 1, label: 'Gia sư đặc biệt' },
        { id: 2, label: 'Gia sư sau khai giảng' },
        { id: 3, label: 'Gia sư lớp đệm' },
        { id: 4, label: 'Gia sư chính sách' },
        { id: 5, label: 'Gia sư quân sự' },
        { id: 6, label: 'Gia sư thi lại' },
        { id: 8, label: 'Gia sư bổ trợ' }
      ],
      starList: [
        { name: '1 sao', id: 1 },
        { name: '2 sao', id: 2 },
        { name: '3 sao', id: 3 },
        { name: '4 sao', id: 4 },
        { name: '5 sao', id: 5 }
      ],
      taskTypes: [],
      assignees: [],
      rows: [],
      page: 1,
      lastPage: 1,
      total: 0,
      loading: false,
      allTutor: [],
      deleteOtherTaskVisible: false,
      deleteTutorTaskVisible: false,
      cancellationReason: '',
      selectedTask: null,
      loadingExport: false,
      exportModalVisible: false,
      exportDataType: 'tutor',
      exportStudentFilters: {
        registrationStatus: null,
        tutorSubtype: 8,
        teacherReviewDateRange: [],
        branchId: null
      },
      exportBranches: [],
      loadingExportBranches: false
    };
  },
  methods: {
    openCreate() {
      this.$bvModal.show('create-task-tutor');
    },
    openExportModal() {
      this.exportDataType = 'tutor';
      this.exportStudentFilters = {
        registrationStatus: null,
        tutorSubtype: 8,
        teacherReviewDateRange: [],
        branchId: null
      };
      this.exportModalVisible = true;
    },
    async onExportTypeChange(type) {
      if (type !== 'student' || this.exportBranches.length || this.loadingExportBranches) return;

      this.loadingExportBranches = true;
      try {
        const { data: branches } = await ApiService.query(GET_ALL_BRANCHES);
        if (!Array.isArray(branches)) throw new Error('Invalid branch list');
        this.exportBranches = branches;
      } catch (e) {
        this.$notify.error({ title: 'Lỗi', message: 'Không thể tải danh sách cơ sở.' });
      } finally {
        this.loadingExportBranches = false;
      }
    },
    closeExportModal() {
      this.exportModalVisible = false;
    },
    handleExportData() {
      if (this.exportDataType === 'tutor') {
        this.ExportData();
        return;
      }

      this.exportStudentData();
    },
    async ExportData() {
      const payload = {
        page: this.page,
        id: this.filters.code,
        type: this.filters.taskType,
        object_handle: this.filters.target,
        status: this.filters.status,
        dateRange: this.filters.startRange,
        createdAtRange: this.filters.createRange,
        admin_profile_id: this.filters.assignee,
        subtypes: this.filters.taskType === 4 ? this.filters.tutorType : null,
        rating: this.filters.starRate
      };
      this.loadingExport = true;
      const EXPORT_TUTOR = [
        { key: 'ma_tac_vu', value: 'Mã tác vụ' },
        { key: 'trung_tam_hoc_vien', value: 'Trung tâm học viên' },
        { key: 'chi_nhanh_hoc_vien', value: 'Chi nhánh học viên' },
        { key: 'phan_loai_gia_su', value: 'Phân loại gia sư' },
        { key: 'noi_dung_gia_su', value: 'Nội dung gia sư' },
        { key: 'noi_dung_gia_su_khac', value: 'Nội dung gia sư (khác)' },
        { key: 'trinh_do_hoc', value: 'Trình độ học' },
        { key: 'thoi_luong_gia_su_gio', value: 'Thời lượng gia sư' },
        { key: 'ma_gia_su_phu_trach', value: 'Mã gia sư phụ trách' },
        { key: 'ten_gia_su_phu_trach', value: 'Tên gia sư phụ trách' },
        { key: 'ho_ten_hoc_vien', value: 'Họ và tên học viên' },
        { key: 'so_dien_thoai_hoc_vien', value: 'Số điện thoại học viên' },
        { key: 'ma_lop', value: 'Mã lớp' },
        { key: 'link_zalo_ho_tro', value: 'Link zalo hỗ trợ' },
        { key: 'ngan_sach_phong_ban', value: 'Ngân sách phòng ban' },
        { key: 'cong_cu_day_hoc', value: 'Công cụ dạy học' },
        { key: 'thoi_gian_bat_dau', value: 'Thời gian bắt đầu' },
        { key: 'thoi_gian_ket_thuc', value: 'Thời gian kết thúc' },
        { key: 'thoi_gian_tao', value: 'Thời gian tạo' },
        { key: 'thoi_gian_hoan_thanh', value: 'Thời gian hoàn thành' },
        { key: 'thoi_gian_huy', value: 'Thời gian hủy' },
        { key: 'thoi_gian_vao_day', value: 'Thời gian vào dạy' },
        { key: 'ma_nhan_su_vao_day', value: 'Mã nhân sự vào dạy' },
        { key: 'ma_nhan_su_hoan_thanh_ca', value: 'Mã nhân sự hoàn thành ca' },
        { key: 'doi_tuong_huy_ca', value: 'Đối tượng hủy ca' },
        { key: 'ma_nguoi_huy_ca', value: 'Mã người hủy ca' },
        { key: 'phan_loai_huy_ca', value: 'Phân loại hủy ca' },
        { key: 'nguyen_nhan_huy', value: 'Nguyên nhân hủy' },
        { key: 'danh_gia_sao', value: 'Đánh giá sao' },
        { key: 'the_feedback', value: 'Thẻ feedback' },
        { key: 'feedback_chi_tiet', value: 'Feedback chi tiết' },
        { key: 'so_hoc_vien_toi_da', value: 'Số học viên tối đa' },
        { key: 'so_hoc_vien_da_dang_ky', value: 'Số học viên đã đăng kí' },
      ];
      try {
        const res = await this.$store.dispatch(EXPORT_TUTOR_TASK_MANAGEMENT, payload);
        exportExcel(this.getExportHeaderStyle(EXPORT_TUTOR), res.data, 'Danh sách tác vụ gia sư.xlsx', false);
        this.closeExportModal();
      } catch (e) {
        this.$notify.error({
          title: 'Lỗi',
          message: e?.message || 'Không thể export dữ liệu. Vui lòng thử lại.'
        });
      } finally {
        this.loadingExport = false;
      }
    },
    exportStudentData() {
      const payload = {
        type: 4,
        subtypes: this.exportStudentFilters.tutorSubtype, 
        status: this.exportStudentFilters.registrationStatus,
        teacherReviewDateRange: this.exportStudentFilters.teacherReviewDateRange || [],
        branch_id: this.exportStudentFilters.branchId
      };
      const EXPORT_STUDENT = [
        { key: 'loai_gia_su', value: 'Loại gia sư' },
        { key: 'ma_ca', value: 'Mã ca' },
        { key: 'ma_lop', value: 'Mã lớp' },
        { key: 'ma_lop_chinh', value: 'Mã lớp chính' },
        { key: 'trinh_do_hoc', value: 'Trình độ học' },
        { key: 'nang_luc_phai_hoc', value: 'Năng lực phải học' },
        { key: 'ki_nang', value: 'Kĩ năng' },
        { key: 'trinh_do_nang_luc', value: 'Trình độ năng lực' },
        { key: 'thoi_gian_bat_dau', value: 'Thời gian bắt đầu' },
        { key: 'thoi_gian_ket_thuc', value: 'Thời gian kết thúc' },
        { key: 'ma_admin_giang_day', value: 'Mã admin giảng dạy' },
        { key: 'admin_giang_day', value: 'Admin giảng dạy' },
        { key: 'ma_hoc_vien', value: 'Mã học viên' },
        { key: 'ho_va_ten_hoc_vien', value: 'Họ và tên học viên' },
        { key: 'so_dien_thoai_hoc_vien', value: 'Số điện thoại học viên' },
        { key: 'co_so', value: 'Cơ sở' },
        { key: 'trang_thai_diem_danh', value: 'Trạng thái điểm danh' },
        { key: 'trang_thai_nang_luc', value: 'Trạng thái năng lực' },
        { key: 'trang_thai_dang_ky', value: 'Trạng thái đăng ký' },
        { key: 'thoi_gian_gv_nhan_xet', value: 'Thời gian giáo viên nhận xét' }
      ];

      this.loadingExport = true;
      this.$store.dispatch(EXPORT_SUPPLEMENTARY_TUTOR_STUDENTS, payload)
        .then((res) => {
          if (!res || !res.data || !res.data.length) {
            this.$notify.warning({
              title: 'Thông báo',
              message: 'Không có dữ liệu để xuất.'
            });
            return;
          }
          exportExcel(this.getExportHeaderStyle(EXPORT_STUDENT), res.data, 'Danh sách học viên gia sư bổ trợ.xlsx', false);
          this.closeExportModal();
        })
        .catch((e) => {
          this.$notify.error({
            title: 'Lỗi',
            message: e?.message || 'Không thể export dữ liệu. Vui lòng thử lại.'
          });
        })
        .finally(() => {
          this.loadingExport = false;
        });
    },
    getExportHeaderStyle(header) {
      return header.map((column) => ({
        ...column,
        align: 'center',
        alignVertical: 'center',
        backgroundColor: '#5E00B6',
        color: '#FFFFFF',
        fontWeight: 'bold',
        wrap: true
      }));
    },
    statusLabel(val) {
      switch (val) {
        case 0:
          return 'Cần làm';
        case 1:
          return 'Hoàn thành';
        case 2:
          return 'Hủy';
        case 3:
          return 'Cần chấm BTVN';
        case 4:
          return 'Hoàn thành buổi học';
        case 5:  case 6:
          return 'Cần đánh giá';
        default:
          return '';
      }
    },
    async getList(isFirstPage = false) {
      try {
        const payload = {
          page: isFirstPage ? 1 : this.page,
          id: this.filters.code,
          type: this.filters.taskType,
          object_handle: this.filters.target,
          status: this.filters.status,
          dateRange: this.filters.startRange,
          createdAtRange: this.filters.createRange,
          admin_profile_id: this.filters.assignee,
          subtypes: this.filters.taskType === 4 ? this.filters.tutorType : null,
          rating: this.filters.starRate
        };
        try {
          this.$router.replace({ query: payload });
        } catch (e) {
          
        }  
        this.loading = true;
        const res = await this.$store.dispatch(GET_LIST_TASK, payload);
        const apiRows = res.data.map((item) => ({
          id: item.id,
          code: item.id,
          taskTypeName: item.type_label,
          categoryName: +item.subtype === 8 ? 'Gia sư bổ trợ' : item.subtype_label,
          target: item.handler?item.handler==='N/A'?'-':item.handler:'-',
          status: item.status,
          workTime: item.work_time,
          assigneeName: item.assignee || "-",
          createdAt: item.created_at,
          rating: item.rating ?? '',
          ...item
        }));
        const mockRows = this.filterMockRows(payload);
        this.rows = [...mockRows, ...apiRows];
        this.page = res.pagination.current_page;
        this.lastPage = res.pagination.last_page;
        this.total = res.pagination.total + mockRows.length;
      } catch (e) {
        console.log(e,111111111);
      } finally {
        this.loading = false;
      }
    },
    filterMockRows(payload) {
      const mockRows = getSupplementTutorMockTasks();

      return mockRows.filter((item) => {
        if (payload.type && +payload.type !== 4) {
          return false;
        }

        if (payload.id && !String(item.id).includes(String(payload.id))) {
          return false;
        }

        if (payload.status !== null && payload.status !== undefined && payload.status !== '' && +item.status !== +payload.status) {
          return false;
        }

        if (payload.subtypes && payload.subtypes.length && !payload.subtypes.includes(8)) {
          return false;
        }

        if (payload.object_handle && !String(item.target).toLowerCase().includes(String(payload.object_handle).toLowerCase())) {
          return false;
        }

        if (payload.rating && payload.rating.length && !payload.rating.includes(item.rating)) {
          return false;
        }

        if (payload.createdAtRange && payload.createdAtRange.length === 2) {
          const createdDate = item.createdAt.split(' ')[0].split('/').reverse().join('-');
          if (createdDate < payload.createdAtRange[0] || createdDate > payload.createdAtRange[1]) {
            return false;
          }
        }

        if (payload.dateRange && payload.dateRange.length === 2) {
          const workDate = item.detail.study_date;
          if (workDate < payload.dateRange[0] || workDate > payload.dateRange[1]) {
            return false;
          }
        }

        return true;
      });
    },
    async getTaskTypes() {
      this.taskTypes = [
        { id: 4, name: 'Gia sư' },
        { id: 5, name: 'Tác vụ khác' }
      ];
    },
    async getAssignees() {
      this.assignees = [
        { id: 10, name: 'Nguyễn Văn A', phone: '0977865321' },
        { id: 11, name: 'Nguyễn Văn B', phone: '0977865321' }
      ];
    },
    clickPage(p) {
      this.page = p;
      this.getList();
    },
    editTask(row) {
      this.selectedTask = row;
      nextTick(() => {
        if (row.taskTypeName === 'Tác vụ khác') {
          this.$bvModal.show('edit-other-task');
        } else {
          this.$bvModal.show('edit-tutor-task');
        }
      });
    },
    actionMarkHomework(task) {
      this.$router.push({
        name: "mark-homework-v2",
        params: { id: task.detail.classroom_id },
        query: {
          classroom_id: task.detail.classroom_id,
          overall_id: task.detail.overall_id,
          lesson: task.detail.lesson,
          student_id: task.user_id,
          typeReMark: 'remark-tutor',
          isTutor: 1
        }
      });
    },
    getClassType(type) {
      if (+type === 4) {
        return 'bg-type-tutor';
      }
      if (+type === 5) {
        return 'bg-type-other';
      }
      return '';
    },
    isMockSupplementTask(row) {
      return String(row?.id || row?.code || '').startsWith('SUP-');
    },
    getClassStatus(status) {
      switch (status) {
        case 0:
          return 'bg-status-wait';
        case 1:
          return 'bg-status-success';
        case 2:
          return 'bg-status-cancel';
        case 3:
          return 'bg-status-need';
        case 4:
          return 'bg-status-success-hw';
        case 5: case 6:
          return 'bg-status-need-review';
        default:
          return '';
      }
    },
    async deleteTask(row) {
      this.selectedTask = row;
      if (row.taskTypeName === 'Tác vụ khác') {
        this.deleteOtherTaskVisible = true;
      } else {
        this.deleteTutorTaskVisible = true;
      }
    },
    cancelDeleteTutor() {
      this.cancellationReason = '';
      this.deleteTutorTaskVisible = false;
    },
    async getUser() {
      const res = await this.$store.dispatch(GET_ALL_TUTOR);
      this.allTutor = res.data;
    },
    async deleteOtherTask() {
      try {
        await this.$store.dispatch(DELETE_OTHER_TASK, this.selectedTask.id);
        this.$notify({
          title: 'Success',
          message: 'Xóa tác vụ thành công',
          type: 'success'
        });
        this.deleteOtherTaskVisible = false;
        await this.getList(true);
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: `${e?.message ?? 'Đã có lỗi xảy ra'}`
        });
      }
    },
    async deleteTutorTask() {
      try {
        await this.$store.dispatch(CANCEL_TUTOR_TASK, { reason: this.cancellationReason, id: this.selectedTask.id });
        this.$notify({
          title: 'Success',
          message: 'Hủy ca học thành công',
          type: 'success'
        });
        this.deleteTutorTaskVisible = false;
        await this.getList(true);
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: `${e?.message ?? 'Đã có lỗi xảy ra'}`
        });
      }
    },
    openImportModal() {
      this.$bvModal.show('import-modal');
    }
  },
  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Gia sư", route: "" },
      { title: "Quản lý tác vụ" }
    ]);
    await this.getUser();
    await Promise.all([this.getTaskTypes(), this.getAssignees()]);
    const query = this.$route.query;
    this.page = query?.page ?? 1;
    this.filters = {
      code: query.id ?? '',
      taskType: toNumber(query?.type),
      target: query.object_handle ?? '',
      status: toNumber(query.status),
      startRange: toArray(query.dateRange),
      assignee: toNumber(query.admin_profile_id),
      createRange: toArray(query.createdAtRange),
      starRate: toNumberArray(query.rating) ?? [],
      tutorType: toNumber(query.type) === 4 ? toNumberArray(query.subtypes) : []
    };
    await this.getList();
  }
};
</script>

<style scoped>
.right-div {
  min-width: 220px;
}

.gap-3 > * {
  margin: 0.5rem;
}

.grid-filter {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
  margin: 20px 0;
}

.bg-status-success {
  background: #1BC5BD;
  color: white;
}

.bg-status-need {
  background: #7000FF;
  color: white;
}

.bg-status-wait {
  background: #FFC424;
  color: black;
}

.bg-status-success-hw {
  background: #0A51BC;
  color: white;
}

.bg-status-cancel {
  background: #575757CC;
  color: white;
}

.bg-status-need-review {
  background: #FF8A00;
  color: white;
}

.bg-type-tutor {
  background: #0066FF;
  color: white;
}

.bg-type-other {
  background: #FFADAD;
  color: black;
}

::v-deep .export-data-dialog {
  border-radius: 5px;
}

::v-deep .export-data-dialog .el-dialog__header {
  display: none;
}

::v-deep .export-data-dialog .el-dialog__body {
  padding: 0;
}

.export-data-modal {
  padding: 37px 19px 31px;
  color: #191c1e;
}

.export-data-modal__title {
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.32px;
  line-height: normal;
  text-align: center;
}

.export-data-modal__divider {
  height: 1px;
  margin: 20px 0;
  background: #d6d5d5;
}

.export-data-modal__options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 8px;
}

::v-deep .export-data-modal__options .el-radio {
  display: flex;
  align-items: center;
  height: 24px;
  margin: 0;
  color: #191c1e;
  font-family: 'Hanken Grotesk', sans-serif;
  font-size: 16px;
  line-height: 24px;
}

::v-deep .export-data-modal__options .el-radio__inner {
  width: 20px;
  height: 20px;
  border-color: #737782;
}

::v-deep .export-data-modal__options .el-radio__input.is-checked .el-radio__inner {
  border: 3px solid #5e00b6;
  background: #fff;
}

::v-deep .export-data-modal__options .el-radio__inner::after {
  width: 8px;
  height: 8px;
  background-color: #5e00b6;
}

::v-deep .export-data-modal__options .el-radio__input.is-checked + .el-radio__label {
  color: #191c1e;
}

::v-deep .export-data-modal__options .el-radio__label {
  padding-left: 12px;
  font-size: 16px;
}

.export-data-modal__filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 34px;
  margin-top: 22px;
}

.export-data-modal__field {
  min-width: 0;
}

.export-data-modal__field label {
  display: block;
  margin-bottom: 7px;
  font-size: 14px;
}

.export-data-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

.export-data-modal__actions button {
  height: 30px;
  padding: 0;
  border-radius: 5px;
  font-family: 'Hanken Grotesk', sans-serif;
  font-size: 16px;
  line-height: 24px;
}

.export-data-modal__close {
  width: 75px;
  border: 0.5px solid #b3b3b3;
  background: #f8f8f8;
  color: #b3b3b3;
}

.export-data-modal__submit {
  width: 86px;
  border: 0;
  border-radius: 2px !important;
  background: #5e00b6;
  color: #fff;
}

.export-data-modal__submit:disabled {
  opacity: 0.7;
}

@media (max-width: 640px) {
  ::v-deep .export-data-dialog {
    max-width: calc(100vw - 32px);
  }

  .export-data-modal__filters {
    grid-template-columns: 1fr;
  }
}
</style>
